import React, { useState } from 'react';
import styles from './linkGenerator.scss';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../types';
import FragmentPlaceholder from '../../fragmentPlaceholder/fragmentPlaceholder';
import classNames from 'classnames';

const LinkGenerator = inject('store')(
    observer(({ store }: IInjectedProps) => {
        const [showContainer, setShowContainer] = useState(true);
        const [showTimeMachine, setShowTimeMachine] = useState(false);

        const handleToggleClick = () => {
            setShowContainer(prev => !prev);
          };

        const handleTimemachineToggleClick = () => {
            setShowTimeMachine(prev => !prev);
          };

        const clickToCopy = (copiedText: string | null) => {
            if (copiedText) {
              navigator.clipboard.writeText(copiedText);
              alert('Copied to clipboard!');
            }
        }  

        const getMagicLink = (): string => {
            if(store?.orderModuleStore?.variantFlexSetId){
                const fscode = store?.dataStore.orderModule.flexSetInfo.fsCode;
                const variantId = store?.orderModuleStore?.variantFlexSetId?.toString();
                return `flexibleset://${fscode}?VariantId=${variantId}`;
            }
            return '';
        }

        const getUrlOfVariant = (): string => {
            const originalUrl = store?.dataStore.contextData.originalUrl;
            const variantId = store?.orderModuleStore?.variantFlexSetId?.toString();

            if (!originalUrl || originalUrl === 'undefined' || !variantId) {
                return '';
            }

            try {
                const parsedUrl = new URL(originalUrl);
                parsedUrl.searchParams.set('VariantId', variantId);
                return parsedUrl.toString();
            } catch {
                return '';
            }
        }

        const magicLink = getMagicLink();
        const urlOfVariant = getUrlOfVariant();
        const variantFlexSetGuid = store?.orderModuleStore?.variantFlexSetId?.toString() ?? null

        return (
            <div className={classNames(
                    styles.link_generator_container, 
                    {[styles.hidden]: !showContainer}
            )} >
                <button className={styles.debug_bar_button} onClick={handleToggleClick}>
                    × Hide DebugBar
                </button>
                <div className={styles.link_generator_info_container}>
                    <button 
                        className={styles.debug_bar_button} 
                        onClick={() => store?.orderModuleStore.saveVariantFlexSetId()}>
                        Create VariantFlexSetId
                    </button>

                    <label className={styles.link_generator_info_item} >
                            <span className={styles.label_Key}>VariantFlexSet Guid: </span>
                            <span className={styles.label_Value}
                                title="Click to copy to clipboard"
                                onClick={() => clickToCopy(variantFlexSetGuid)}>
                                    {variantFlexSetGuid}
                            </span>
                    </label>
                    <label className={styles.link_generator_info_item} >
                            <span className={styles.label_Key}>Magic Link: </span>
                            <span className={styles.label_Value}
                                title="Click to copy to clipboard"
                                onClick={() => clickToCopy(magicLink)}>
                                    {magicLink}
                            </span>
                    </label>
                    <label className={styles.link_generator_info_item} >
                            <span className={styles.label_Key}>Url: </span>
                            <span className={styles.label_Value}
                                title="Click to copy to clipboard"
                                onClick={() => clickToCopy(urlOfVariant)}>
                                    {urlOfVariant}
                            </span>
                    </label>
                </div>
                <button  className={styles.debug_bar_button} onClick={handleTimemachineToggleClick}>
                    {showTimeMachine ? 'Hide Timemachine' : 'Show Timemachine'}
                </button>
                <div className={classNames(
                        styles.link_generator_timemachine_container, 
                        {[styles.hidden] : !showTimeMachine}
                )}>
                    <FragmentPlaceholder src='/escid.esp.timemachine.api/fragment' ignoreErrors={true} timeout={1} />
                </div>
            </div >
        );
    })
);

export default LinkGenerator;
